import {Component} from "@angular/core";
import {formatCurrency} from "@angular/common";

@Component({
  selector: 'app-detail-table',
  templateUrl: './mandates-table.component.html',
  styleUrls: ['../../detail-screen/detail-screen.component.css'],
})

export class MandatesTableComponent {
  tableColumns: string[];
  tableData: any[];
  emptyValuePlaceholder = '';
  showTable: boolean;

  constructor() {
    this.tableColumns = [];
    this.tableData = [];
    this.showTable = true;
  }

  formIncassant(data) {
    if (data.incassantnaam) {
      let incassantData = data.incassantnaam;
      if (data.incassantId) {
        incassantData = incassantData + ' (' + data.incassantId + ') ';
      }
      if (data.inzake) {
        incassantData = incassantData + 'inzake ' + data.inzake;
      }
      return incassantData;
    }
    return this.emptyValuePlaceholder;
  }

  formMachtiging(data) {
    if (data.machtigingsKenmerk) {
      let machtigingData = data.machtigingsKenmerk;
      if (data.machtigingsType.toUpperCase() === "RCUR") {
        machtigingData = machtigingData + ' (doorlopend)';
      } else if (data.machtigingsType.toUpperCase() === "OOFF") {
        machtigingData = machtigingData + ' (eenmalig)';
      }
      return machtigingData;
    }
    return this.emptyValuePlaceholder;
  }

  formOmscrijving(data) {
    let omschrijvingData = '-';
    if (data.omschrijving) {
      omschrijvingData = data.omschrijving;
    }
    if (data.aankoopId) {
      omschrijvingData = omschrijvingData + ' ' + data.aankoopId;
    }
    return omschrijvingData;
  }

  formDatumIngevoerd(data) {
    if (data.machtigingDatum && data.machtigingDatum.length > 3) {
      return data.machtigingDatum[2] + '-' + data.machtigingDatum[1] + '-' + data.machtigingDatum[0];
    }
    return this.emptyValuePlaceholder;
  }

  formSoort(data) {
    if (data.procesSchema) {
      let soortData = '';
      if (data.procesSchema.toUpperCase() === 'SDDB2B') {
        soortData = 'Bedrijven incassomachtiging';
      } else if (data.procesSchema.toUpperCase() === 'SDDCORE') {
        soortData = 'Incassomachtiging';
      }
      if (data.elektronisch && data.elektronisch === 'Y') {
        soortData = soortData + ' (digitaal)';
      }
      return soortData;
    }
    return this.emptyValuePlaceholder;
  }

  formMaxBedrag(data) {
    if (data.maximumBedrag) {
      if (data.maximumBedrag.currencyCode === 'EUR') {
        return formatCurrency(data.maximumBedrag.amount, 'nl', '€');
      } else {
        return data.maximumBedrag.currencyCode + ' ' + data.maximumBedrag.amount;
      }
    } else if (data.procesSchema === 'SDDCORE') {
      return 'n.v.t.';
    } else if (data.procesSchema === 'SDDB2B') {
      return 'ongelimiteerd';
    }
  }


  formStatus(data) {
    if(data.status && data.goedkeuringStatus) {
      const status = data.status.toUpperCase();
      const goedkeuringStatus = data.goedkeuringStatus.toUpperCase();
      switch(status) {
        case 'ACTIVE':
        case 'INACTIVE':
          if(goedkeuringStatus === 'APPROVED') {
            return 'Actief';
          } else if (goedkeuringStatus === 'AWAITINGAPPROVAL') {
            return 'Te beoordelen';
          } else if (goedkeuringStatus === 'DECLINED') {
            return 'Geweigerd';
          }
          break;
        case 'REVOKED':
          if(goedkeuringStatus === 'APPROVED') {
            return 'Geblokkeerd';
          }
          break;
        case 'OBSOLETE':
          if (goedkeuringStatus === 'APPROVED') {
            return 'Verlopen';
          } else if (goedkeuringStatus === 'DECLINED') {
            return 'Ingetrokken';
          }
          break;
        default:
          return this.emptyValuePlaceholder;
      }
    }
    return this.emptyValuePlaceholder;
  }

  formLatestDateAndAmount(data) {
    let formedData = '';
    if (data.laatsteMachtigingDatum && data.laatsteMachtigingDatum.length > 2) {
      formedData = data.laatsteMachtigingDatum[2] + '-'
                 + data.laatsteMachtigingDatum[1] + '-'
                 + data.laatsteMachtigingDatum[0];
    }
    if (data.laatsteMachtigingBedrag) {
      if (data.laatsteMachtigingBedrag.currencyCode === 'EUR') {
        formedData = formedData + ' (' + formatCurrency(data.laatsteMachtigingBedrag.amount, 'nl', '€') + ')';
      } else {
        formedData = formedData + ' (' + data.laatsteMachtigingBedrag.currencyCode + ' ' + data.laatsteMachtigingBedrag.amount + ')';
      }
    }
    return formedData;
  }

}
